import React from 'react';
import styles from './TextEffectsSticker.scss';
import type { TextEffectsSharedProps } from '../../TextEffectsShared/TextEffectsShared.types';
import TextEffectsShared from '../../TextEffectsShared/viewer/TextEffectsShared';
import { TestIds } from '../constants';
import cx from 'clsx';

export type TextEffectsStickerProps = TextEffectsSharedProps;

const TextEffectsSticker: React.FC<TextEffectsSharedProps> = props => {
  const { text } = props;

  return (
    <TextEffectsShared
      {...props}
      tagProps={{
        className: styles.wrapper,
        'data-text': text,
        'data-testid': TestIds.viewer.container,
      }}
    >
      <span
        data-testid={TestIds.viewer.text}
        className={cx(styles.text, styles.block)}
      >
        {text}
      </span>
    </TextEffectsShared>
  );
};

export default TextEffectsSticker;
